import { Pipe, PipeTransform } from '@angular/core';

import { Comment } from '../providers/bridge-api/dashboard.service';

@Pipe({
  name: 'pinnedCommentPipe',
  pure: false,
  standalone: false,
})
export class PinnedCommentPipe implements PipeTransform {
  transform(comments: Comment[]) {
    return comments.find((comment) => comment.summaryPinned || comment.titlePinned);
  }
}
